import encodeRFC3986URIComponent from "./encodeRFC3986URIComponent";

export const operators = [
  {value: 'in', label: 'is one of'},
  {value: 'not', label: 'is not'},
  {value: 'isNull', label: 'no value'},
];

export function getApiParam(field, filter) {
  switch (filter.operator) {
    case 'in':
      return `in(${filter.value.map(encodeRFC3986URIComponent).join('|')})`;
    case 'not':
      return `not(${filter.value.map(encodeRFC3986URIComponent).join('|')})`;
    case 'isNull':
      return 'is(null)';
  }
}

export function isValid(filter) {
  if (filter.operator === 'isNull') {
    return true;
  } else {
    return Array.isArray(filter.value)
      && filter.value.length > 0;
  }
}

export function getFormattedValue(field, filter) {
  switch (filter.operator) {
    case 'isNull':
      return 'no value';
    case 'not':
      return 'not ' + listOfValues(field, filter);
    case 'in':
    default:
      return listOfValues(field, filter);
  }
}

function listOfValues(field, filter) {
  const options = field.params.options;
  if (filter.value.length === options.length && !field.params.listAll) {
    return 'All';
  }
  if (Array.isArray(filter.value)) {
    return filter.value.map(value => {
      // If it's a string
      if (options.includes(value)) {
        return value;
      }
      // If we have a {label: 'x', value: 'y'} jawn
      return options.find(option => option.value === value).label;
    }).join(', ');
  }
}

